// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__juZjK","field":"styles_field__1Zz31","fieldCol":"styles_fieldCol__2XQLF","diffCol":"styles_diffCol__2ssel","diff":"styles_diff__1WSSV"};